import React from "react";
import "./header.css";
import { Link } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const Header = () => {
  return (
    <header>
      <Link to="/">
        <img
          src="../../../images/40f-a.png"
          alt="40 Figuritas por 40 años de democracia"
        />
      </Link>
    </header>
  );
};

export default Header;
